<template>
  <div class="my-button">
    {{text}}
  </div>
</template>

<script>
export default {
  props: ['text'],
  name: 'Button'
}
</script>

<style lang="scss" scoped>
  .my-button {
    min-width: 98px;
    font-size: 14px;
    color: #fff;
    border-radius: 25px;
    padding: 10px 26px;
    background-image: linear-gradient(to right, #96DEFF, #EAAFFF);
  }
</style>
